<template>
    <div class="card-body">
        <h5 class="card-title">Popular Category</h5>
        <div class="d-flex p-5 justify-content-center" v-if="loading">
            <app-loading />
        </div>
        <div class="row scroller custom-scrollbar" v-else>
            <div class="col-md-3 col-sm-6"
                 v-for="category in categories"
            >
                <category-card
                        :category="category"
                        :key="category.id"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import CategoryCard from "./CategoryCard";

    export default {
        name: "PopularCategories",
        components: {CategoryCard},
        data() {
            return {
                loading: false,
                categories: []
            }
        },
        methods: {
            getPopularCategories() {
                this.loading = true;

                window
                    .axios
                    .get('/client/category/popular-categories')
                    .then(response => {
                        this.categories = response.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            }
        },
        created() {
            this.getPopularCategories();
        }
    }
</script>

<style scoped>
    .scroller {
        max-height: 380px;
        overflow: auto;
    }
</style>